import { InsightsIncomeSkeleton } from '@/components/ui'
import {
  ReconciliationOverview,
  useFetchProject,
  useLoadingStatements,
} from '@/modules/projects'

interface ReconciliationPageProps {
  slug: string
}

// Built from statements already in the store, so no generation pass is needed. Open to every
// account: the side-by-side of a cycle and its transactions is not the premium part, the reconcile
// verdict is, and the server withholds that on its own.
export function ReconciliationPage({ slug }: ReconciliationPageProps) {
  useFetchProject(slug)

  const isLoading = useLoadingStatements()

  if (isLoading) return <InsightsIncomeSkeleton />

  return <ReconciliationOverview />
}
